define('viewmodels/VisualAnalytics/ControlsWeightings',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system', 'services/utils', 'viewmodels/GeneralSettings'],
    function (ko, router, appsecurity, navigation, app, logger, system, utils, ObjGeneralSettings) {
        var title = 'ControlsWeightings';

        var CWViewModel = {
            activate: activate,
            title: title,
            attached: attached,
            detached: detached,
            appsecurity: appsecurity,
            AssessmentTypeId: ko.observable(),
            AssessmentType: ko.observable(),
            ScreenName: ko.observable(),
            SurveyCategoryListCw: ko.observableArray([]),
            BusinessLevelList: ko.observableArray([]),
            SurveyCategoryTabClickCw: SurveyCategoryTabClickCw,
            RiskLevelTabClick: RiskLevelTabClick,
            SurveyTypeClicked: ko.observable(),
            AreaLeveljstree: ko.observableArray([]),
            SurveyCategoryID: ko.observable(),
            CollapseAllTreeView: CollapseAllTreeView,
            BusinessUnits: ko.observableArray([]),
            AreasOrQuestions: ko.observableArray([]),
            ControlsWeight: ko.observableArray([]),
            weightingsTableTitle: ko.observable(),

            EditBUWeights: EditBUWeights,
            SelectBusinessUnit: ko.observable(),
            EditableBusinessUnitName: ko.observable(),
            selectedAreaId: ko.observable(),
            saveWeights: saveWeights,
            WeightingsList: ko.observableArray([]),
            IsDeadNode: ko.observable(0),
            checkCopyOver: checkCopyOver,
            totalWeightList: ko.observableArray([]),
            EditableBusinessunitTotal: ko.observable(0),
            RefreshWeights: RefreshWeights,
            uploadDownloadDetails: ko.observable(),
            UploadFileSize: ko.observable(1073741824),
            SelectedOrgLevel: ko.observable(),
            GetTaxonomyLevels: GetTaxonomyLevels,
            TaxonomyLevels: ko.observableArray([]),
            selectedOrgLevelAP: ko.observable(),
            IsLowestLevelSelected: ko.observable(false),
            TaxonomyLevelChanged: TaxonomyLevelChanged,
            GetQuestionTypes: GetQuestionTypes,
            selectedTaxonomyLevel: ko.observable(),
            QuestionTypes: ko.observableArray([]),
            decimalLimit: ko.observable(5),
            decimalOptions: ko.observableArray(['2', '3', '4', '5']),
            BreadCrumbArray: ko.observable([]),
            screenType: ko.observable(),
            ControlsAccess: ko.observable(true),
            totalValidityFlag: ko.observable(1),
            hasChildNodes: ko.observable(false),
            SelectedScenarioId: ko.observable(),
            GetSurveyCategoryTabsCW: GetSurveyCategoryTabsCW,

            ObjGeneralSettings: ObjGeneralSettings,
            LocaleCheckFlag: ko.observable(false),
        };

        return CWViewModel;

        function activate() {
            try {

                if (CWViewModel.ObjGeneralSettings === undefined || CWViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((CWViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || CWViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && CWViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                    CWViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                        if (CWViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || CWViewModel.ObjGeneralSettings.LocalizedTextList() == null || CWViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || CWViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || CWViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                            CWViewModel.LocaleCheckFlag(false);
                        else
                            CWViewModel.LocaleCheckFlag(true);
                    });
                } else
                    CWViewModel.LocaleCheckFlag(true);

                CWViewModel.ScreenName(
                    //'Controls Weightings'
                    (!CWViewModel.LocaleCheckFlag() || CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ControlsWeightings') == -1) ? 'Controls Weightings' : CWViewModel.ObjGeneralSettings.LocalizedTextList()[CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ControlsWeightings')].Name()
                );
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: activate() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function detached() {
            try {

                //var Id = CWViewModel.appsecurity.getParameterByName('atype');
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: detached() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        };

        function attached() {
            try {
                //$('#SurveyCategoryTabCw').hide();
                //$('#mainLoader').show();
                //$("#divNavSwitch2").hide();
                //GetSurveyCategoryTabsCW();

                if (CWViewModel.ObjGeneralSettings === undefined || CWViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((CWViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || CWViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && CWViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                    CWViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                        if (CWViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || CWViewModel.ObjGeneralSettings.LocalizedTextList() == null || CWViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || CWViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || CWViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                            CWViewModel.LocaleCheckFlag(false);
                        else
                            CWViewModel.LocaleCheckFlag(true);
                    });
                }

                CWViewModel.EditableBusinessUnitName(
                    //"Editable BusinessUnit name"
                    (!CWViewModel.LocaleCheckFlag() || CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditableBusinessUnitname') == -1) ? 'Editable BusinessUnit name' : CWViewModel.ObjGeneralSettings.LocalizedTextList()[CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditableBusinessUnitname')].Name()
                );
                GetQuestionTypes();

            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: attached() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }
        function GetSurveyCategoryTabsCW(AssessmentId, ScenarioId, StateSelected) {
            try {

                CWViewModel.AssessmentTypeId(AssessmentId);

                CWViewModel.SelectedScenarioId(ScenarioId);

                $('#loadingMainControlsDiv').show();
                $.ajax({
                    url: "/api/Visualization/GetSurveyCategoryTabsByZATRAT",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { "AssessmentId": CWViewModel.AssessmentTypeId(), "StateSelected": StateSelected }
                })
                    .success(function (jsonResult, success) {
                        try {
                            if (jsonResult !== null) {
                                var mappedTabList = $.map(jsonResult, function (result) {
                                    return new SurveyCategoryModel(result);
                                });
                                CWViewModel.SurveyCategoryListCw(mappedTabList);
                                $($('#SurveyCategoryTabsDivCw li').get(0)).trigger('click');
                                $('#SurveyCategoryTabCw').tabs();
                                $('#SurveyCategoryTabCw').tabs('refresh');
                                $('#SurveyCategoryTabCw').tabs({ active: 0 });
                                scrollableTabs();
                                //$('#loadingMainControlsDiv').hide();
                            }
                            else {
                                //$('#loadingMainControlsDiv').hide();
                            }
                        }
                        catch (e) {
                            let msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabsCW() Success method in ControlsWeightings.js';
                            logger.logMessage(msg);
                        }

                    })
                    .fail(function (error, status) {
                        if (error.status === 401) {
                            app.showMessage(((!CWViewModel.LocaleCheckFlag() || CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : CWViewModel.ObjGeneralSettings.LocalizedTextList()[CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then((option) => {
                                    if (option === "OK")
                                        navigation.unauthorized();
                                });
                        }
                        else {
                            let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyCategoryTabsCW() method in ControlsWeightings.js';
                            logger.logMessage(msg);
                        }

                    });
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabsCW() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }
        function SurveyCategoryTabClickCw(data, event, flag) {
            try {
                CWViewModel.SurveyTypeClicked('CDR');
                CWViewModel.SurveyCategoryID(data.SurveyCategoryId());
                GetTaxonomyLevels();
                GetRiskLevelDetails();
                $('#SurveyCategoryTabsDivCw li').removeClass('active');
                $('#ParentTab_' + data.SurveyCategoryId()).addClass('active');

            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: SurveyCategoryTabClick() method in AMLThresholds.js';
                logger.logMessage(msg);
            }
        }
        function GetRiskLevelDetails() {
            try {
                $.ajax({
                    url: "/api/WeightingsThresholds/getAllBusinessUnitLevels",
                    data: { "type": CWViewModel.AssessmentTypeId(), "Page_Type": "W" },
                    type: "GET",
                    async: false,
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajax call in GetRiskLevelDetails() method in ControlsWeightings.js';
                logger.logMessage(msg);

            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult !== null && jsonResult.length > 0) {
                        var MappedBUModelList = $.map(jsonResult, (result) => {
                            return new BusinessLevelModel(result);
                        });

                        CWViewModel.BusinessLevelList(MappedBUModelList);


                        $('#RaTabCwWIA').tabs();
                        $('#RaTabCwWIA').tabs('refresh');
                        $('#RaTabCwWIA').tabs({ active: 0 });
                        $($('#RaTabCwWIA li').get(0)).trigger('click');
                    }
                    else
                        logger.logError((!CWViewModel.LocaleCheckFlag() || CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : CWViewModel.ObjGeneralSettings.LocalizedTextList()[CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name(), 'Error', system.getModuleId(CWViewModel), true);
                }
                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetRiskLevelDetails() method in ControlsWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }
        function GetTaxonomyLevels() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                getTaxonomyLevel = {

                    url: "/api/WeightingsThresholds/GetTaxonomyLevel",
                    type: "GET",
                    data: {
                        "SurveyCategoryID": CWViewModel.SurveyCategoryID(), "Show_Lowest_Level": 0
                    },
                    headers: headers
                };
                $.ajax(getTaxonomyLevel)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetTaxonomyLevels() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                if (jsonResult !== null) {
                    CWViewModel.TaxonomyLevels([]);
                    var MappedTaxonomyLevel = $.map(jsonResult, function (result) {
                        return new TaxonomyModel(result);
                    });
                    CWViewModel.TaxonomyLevels(MappedTaxonomyLevel);

                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage(((!CWViewModel.LocaleCheckFlag() || CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : CWViewModel.ObjGeneralSettings.LocalizedTextList()[CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then((option) => {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetTaxonomyLevels method in ControlsWeightings.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail in GetTaxonomyLevels method in ControlsWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function TaxonomyLevelChanged() {
            for (var i = 0; i < CWViewModel.TaxonomyLevels().length; i++) {
                if (CWViewModel.TaxonomyLevels()[i].LevelId() == CWViewModel.selectedTaxonomyLevel()) {
                    if (CWViewModel.TaxonomyLevels()[i].isMaxLevel() == 1) {
                        CWViewModel.IsLowestLevelSelected(true);
                    }
                    else {
                        CWViewModel.IsLowestLevelSelected(false);
                    }

                    break;
                }
            }
        }
        function GetQuestionTypes() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                getTaxonomyLevel = {

                    url: "/api/WeightingsThresholds/GetQuestionTypes",
                    type: "GET",
                    //data: { "RiskAreType": CWViewModel.SurveyTypeClicked(), "SurveyCategoryID": CWViewModel.SurveyCategoryID().toString(), "AssessmentTypes": CWViewModel.AssessmentTypeId().toString(), "ScreenType": 'W' },
                    headers: headers
                };
                $.ajax(getTaxonomyLevel)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetTaxonomyLevels() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                //$('#SurveyCategoryTabCw').show();
                //$('#mainLoader').hide();
                if (jsonResult !== null) {
                    CWViewModel.QuestionTypes([]);
                    var MappedQuestionTypes = $.map(jsonResult, function (result) {
                        return new QuestionTypeModel(result);
                    });
                    CWViewModel.QuestionTypes(MappedQuestionTypes);

                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage(((!CWViewModel.LocaleCheckFlag() || CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : CWViewModel.ObjGeneralSettings.LocalizedTextList()[CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then((option) => {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetQuestionTypes method in ControlsWeightings.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail in GetQuestionTypes method in ControlsWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }
        function RiskLevelTabClick(data, event) {
            try {
                //$('#mainLoader').show();
                //$('#SurveyCategoryTabCw').hide();
                CWViewModel.SelectedOrgLevel(data.Bulevel());
                $('#RiskAreaUlCwWIA li').removeClass('active');
                $('#ChildTab_' + data.Bulevel()).addClass('active');
                if (data.Bulevel() == "0")
                    CWViewModel.screenType("W");
                else
                    CWViewModel.screenType("OW");
                InitiateLevelTree();
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajaxSuccess in RiskLevelTabClick() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }
        function InitiateLevelTree() {
            try {

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                getJsTreeAreaLevel = {

                    url: "/api/Configuration/GetAllRiskAreasForThreshold",
                    type: "GET",
                    data: { "RiskAreType": CWViewModel.SurveyTypeClicked(), "SurveyCategoryID": CWViewModel.SurveyCategoryID().toString(), "AssessmentTypes": CWViewModel.AssessmentTypeId().toString(), "ScreenType": CWViewModel.screenType() },
                    headers: headers
                };
                $.ajax(getJsTreeAreaLevel)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajax call in InitiateLevelTree() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                //$('#mainLoader').hide();
                //$('#SurveyCategoryTabCw').show();
                if (jsonResult !== null) {
                    //implement js tree logic here
                    CWViewModel.AreaLeveljstree(jsonResult.AreaLevelsData);

                    var MappedJsTreeList = $.map(jsonResult.AreaLevelsData["#"], function (result) {
                        return new jsTreeModel(result);
                    });

                    $('#jsTreeAreaLevelCwWIA').treeview({
                        data: MappedJsTreeList,
                        onNodeSelected: nodeClickEvent
                    });


                    $("#jsTreeAreaLevelCwWIA ul:first li:first").trigger("click");
                }
            }

            function filterJsTree(TreeStructure) {

                return TreeStructure.filter(
                    function (item) {
                        if (item.nodes !== undefined && item.nodes.length > 0) {
                            item.nodes = filterJsTree(item.nodes);
                        }

                        if (item.showLevel === 1)
                            return true;
                        return false;

                    }
                );
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage(((!CWViewModel.LocaleCheckFlag() || CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : CWViewModel.ObjGeneralSettings.LocalizedTextList()[CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then((option) => {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in InitiateLevelTree() method in ControlsWeightings.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail in InitiateLevelTree() method in ControlsWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }
        function CollapseAllTreeView() {
            if ($('#spanExpandAll').text() ===
                //"Expand"
                (!CWViewModel.LocaleCheckFlag() || CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : CWViewModel.ObjGeneralSettings.LocalizedTextList()[CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name()
            ) {
                $('#jsTreeAreaLevelCwWIA').treeview('collapseAll', { silent: true });
                $("#spanExpandAll").text(
                    //"Collapse"
                    (!CWViewModel.LocaleCheckFlag() || CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton') == -1) ? 'Collapse' : CWViewModel.ObjGeneralSettings.LocalizedTextList()[CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton')].Name()
                );
            }
            else {
                $('#jsTreeAreaLevelCwWIA').treeview('expandAll', { silent: true });
                $("#spanExpandAll").text(
                    //"Expand"
                    (!CWViewModel.LocaleCheckFlag() || CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : CWViewModel.ObjGeneralSettings.LocalizedTextList()[CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name()
                );
            }
        }

        function EditBUWeights(data, event) {
            try {
                var curr = event.currentTarget.parentElement.children[0].id;
                setSelectedBusinessUnit(curr);
                $("div.dataTables_scrollBody").animate({ scrollLeft: 0 }, 800);

            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: EditBUWeights() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function setSelectedBusinessUnit(id) {
            try {
                for (var i = 0; i < CWViewModel.BusinessUnits().length; i++) {
                    if (CWViewModel.BusinessUnits()[i].BUId() == id) {
                        CWViewModel.SelectBusinessUnit(CWViewModel.BusinessUnits()[i]);
                        break;
                    }
                }
                CWViewModel.EditableBusinessUnitName(CWViewModel.SelectBusinessUnit().BUName());
                CWViewModel.EditableBusinessunitTotal(CWViewModel.SelectBusinessUnit().total());
                for (i = 0; i < CWViewModel.AreasOrQuestions().length; i++) {
                    CWViewModel.AreasOrQuestions()[i].selectedBuWeight(CWViewModel.SelectBusinessUnit().BUWeightings[i].WeightingValue().toFixed(CWViewModel.decimalLimit()));
                    CWViewModel.AreasOrQuestions()[i].Applicability(CWViewModel.SelectBusinessUnit().BUWeightings[i].Applicability());
                }
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: setSelectedBusinessUnit() method in AMLControlsWeightings.js';
                logger.logMessage(msg);
            }

        }

        function BusinessLevelModel(item) {
            try {
                var self = this;
                self.Bulevel = ko.observable($('<div/>').html(item.BuLId).text());
                self.BlName = ko.observable($('<div/>').html(item.BuLevelName).text());
                self.SortOrder = ko.observable($('<div/>').html(item.SortOrder).text());
            } catch (e) {
                let msg = 'Exception: ' + e + ' | Source: BusinessLevelModel() method in AMLControlsWeightings.js';
                logger.logMessage(msg);
            }
        }
        function nodeClickEvent(event, node) {
            try {
                //$('#WeightingsTableDivCwWIA').hide();
                //$('#loadingMainControlsDiv').show();
                CWViewModel.selectedAreaId(node.id);
                CWViewModel.weightingsTableTitle(node.text);
                CWViewModel.IsDeadNode(node.dead_node);
                GetControlsWeight();

            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: BusinessLevelModel() method in AMLControlsWeightings.js';
                logger.logMessage(msg);
            }
        }
        function GetControlsWeight() {
            try {

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Visualization/GetControlsWeights",
                    type: "GET",
                    headers: headers,
                    data: { "AssessmentType": CWViewModel.AssessmentTypeId(), "SurveyCategoryId": CWViewModel.SurveyCategoryID().toString(), "AreaId": CWViewModel.selectedAreaId(), "OrgLevel": CWViewModel.SelectedOrgLevel(), "ScenarioId": CWViewModel.SelectedScenarioId() }
                })
                    .success((jsonResult, success) => {
                        try {

                            //$('#WeightingsTableDivCwWIA').show();
                            //$('#loadingMainControlsDiv').hide();
                            if (jsonResult !== null) {
                                CWViewModel.BusinessUnits([]);
                                CWViewModel.AreasOrQuestions([]);
                                CWViewModel.ControlsWeight([]);
                                // Map Business Units.

                                CWViewModel.decimalLimit(jsonResult.precisionObject);

                                if (jsonResult.BUWiseWeightings.length > 0) {
                                    var mappedBusinessUnitData = $.map(jsonResult.BUWiseWeightings, (result) => {
                                        return new BusinessLevelsModel(result);
                                    });
                                    CWViewModel.BusinessUnits([]);
                                    CWViewModel.BusinessUnits(mappedBusinessUnitData);
                                }

                                CWViewModel.totalValidityFlag(1);

                                for (var i = 0; i < CWViewModel.BusinessUnits().length; i++) {
                                    if (CWViewModel.BusinessUnits()[i].total() == 100.00000 || CWViewModel.BusinessUnits()[i].total() == 0.00000) {
                                        CWViewModel.totalValidityFlag(1);
                                    }
                                    else {
                                        CWViewModel.totalValidityFlag(0);
                                        break;
                                    }
                                }

                                CWViewModel.AreasOrQuestions([]);
                                if (jsonResult.AreaWiseWeightings.length > 0) {
                                    var mappedAreasOrQuestions = $.map(jsonResult.AreaWiseWeightings, (result) => {
                                        return new RiskAreaModel(result);
                                    });
                                    CWViewModel.AreasOrQuestions([]);
                                    CWViewModel.AreasOrQuestions(mappedAreasOrQuestions);
                                }
                                setSelectedBusinessUnit(mappedBusinessUnitData[0].BUId());
                                CWViewModel.ControlsWeight([]);
                                if (jsonResult.WeightingsList.length > 0) {
                                    var mappedControlsWeight = $.map(jsonResult.WeightingsList, (result) => {
                                        return new WeightingsModel(result);
                                    });
                                    CWViewModel.ControlsWeight([]);
                                    CWViewModel.ControlsWeight(mappedControlsWeight);
                                }

                                let scrollHeight = "27rem";

                                if ($.fn.DataTable.isDataTable('#WeightingsTable')) {
                                    CWViewModel.AreasOrQuestions([]);
                                    var tableObj = $('#WeightingsTable').DataTable();
                                    tableObj.fixedHeader.disable();
                                    tableObj.destroy();
                                    $('#WeightingsTable tbody tr').remove();
                                    $("#WeightingsTableHeader > th").remove();
                                    $("#WeightingsTableTotal > th").remove();
                                    var htmlHeader = '';
                                    //Code for header of the table
                                    if (CWViewModel.IsDeadNode() === 1) {
                                        htmlHeader += '<th class="site_name Weightings-Fixed-Column">'
                                        //htmlHeader += //Questions ↓ / Business Units →
                                        htmlHeader += (!CWViewModel.LocaleCheckFlag() || CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('QuestionsvsBusinessUnits') == -1) ? 'Questions ↓ / Business Units →' : CWViewModel.ObjGeneralSettings.LocalizedTextList()[CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('QuestionsvsBusinessUnits')].Name();
                                        htmlHeader += '</th > \
                                                <th class="site_name header-ellipsis" data-bind="text:$root.EditableBusinessUnitName">'+ CWViewModel.EditableBusinessUnitName() + '</th>';
                                    }
                                    else {
                                        htmlHeader += '<th class="site_name Weightings-Fixed-Column" >';
                                        //htmlHeader += 'Areas ↓ / Business Units →';
                                        htmlHeader += (!CWViewModel.LocaleCheckFlag() || CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AreasvsBu') == -1) ? 'Areas ↓ / Business Units →' : CWViewModel.ObjGeneralSettings.LocalizedTextList()[CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AreasvsBu')].Name();
                                        htmlHeader += '</th > \
                                                <th class="site_name header-ellipsis" data-bind="text:$root.EditableBusinessUnitName">'+ CWViewModel.EditableBusinessUnitName() + '</th>';
                                    }
                                    for (var i = 0; i < CWViewModel.BusinessUnits().length; i++) {
                                        htmlHeader += '<th class="site_name header-ellipsis"><div style="display:flex"><label id=' + CWViewModel.BusinessUnits()[i].BUId() + ' title="' + CWViewModel.BusinessUnits()[i].BUName() + '">' + CWViewModel.BusinessUnits()[i].BUName() + '</label> &emsp; <icon class="fa fa-edit float-right float-top" title="Edit Weights" data-bind="click: $root.EditBUWeights"></icon></div></th>';
                                    }

                                    $('#WeightingsTableHeader').html(htmlHeader);
                                    document.getElementById('WeightingsTableHeader').innerHTML = htmlHeader;
                                    ko.cleanNode(document.getElementById('WeightingsTableHeader'));
                                    ko.applyBindings(CWViewModel, document.getElementById("WeightingsTableHeader"));
                                    var htmlFooter = '';
                                    htmlFooter = '<th  class="site_name">Total</th>\
                                        <th class=" text-center heatmap-grey" data-bind="css:{\'heatmap-red\' :($root.EditableBusinessunitTotal()!=100.00000&&$root.EditableBusinessunitTotal()!=0.00000),\'heatmap-grey\' :($root.EditableBusinessunitTotal()==100.00000||$root.EditableBusinessunitTotal()==0.00000)}"> <span data-bind="text:$root.EditableBusinessunitTotal" > </span> <span> % </span></th>';
                                    for (i = 0; i < CWViewModel.BusinessUnits().length; i++) {
                                        if (Number(CWViewModel.BusinessUnits()[i].total()).toFixed(CWViewModel.decimalLimit) != 100.00000 && Number(CWViewModel.BusinessUnits()[i].total()).toFixed(CWViewModel.decimalLimit()) != 0.00000) {
                                            htmlFooter += '<th class="heatmap-red text-center " >' + CWViewModel.BusinessUnits()[i].total() + ' % ' + '</th>';
                                        }
                                        else {
                                            htmlFooter += '<th class="heatmap-grey text-center" >' + CWViewModel.BusinessUnits()[i].total() + ' % ' + '</th>';
                                        }
                                    }
                                    $('#WeightingsTableTotal').append(htmlFooter);
                                    document.getElementById('WeightingsTableTotal').innerHTML = htmlFooter;
                                    ko.cleanNode(document.getElementById('WeightingsTableTotal'));
                                    ko.applyBindings(CWViewModel, document.getElementById("WeightingsTableTotal"));

                                    if (jsonResult.AreaWiseWeightings.length > 0) {
                                        var mappedAandQ = $.map(jsonResult.AreaWiseWeightings, (result) => {
                                            return new RiskAreaModel(result);
                                        });

                                        CWViewModel.AreasOrQuestions(mappedAandQ);
                                        setSelectedBusinessUnit(mappedBusinessUnitData[0].BUId());
                                    }
                                    tableObj = $('#WeightingsTable').DataTable(
                                        {
                                            'aoColumnDefs': [{
                                                'bSortable': false,
                                                "targets": "_all"
                                            }],
                                            "aaSorting": [],
                                            scrollY: scrollHeight,
                                            scrollX: true,
                                            scrollCollapse: true,
                                            paging: false,
                                            "bInfo": false,
                                            "bAutoWidth": false,
                                            fixedColumns: {
                                                leftColumns: 1
                                            },
                                            fixedheader: {
                                                header: true
                                                //footer:true
                                            }

                                        }).draw();


                                }
                                else if (!$.fn.DataTable.isDataTable('#WeightingsTable')) {
                                    $('#WeightingsTable').DataTable(
                                        {
                                            'aoColumnDefs': [{
                                                'bSortable': false,
                                                "targets": "_all"
                                            }],
                                            "aaSorting": [],
                                            scrollY: scrollHeight,
                                            scrollX: true,
                                            scrollCollapse: true,
                                            paging: false,
                                            "bInfo": false,
                                            "bAutoWidth": false,
                                            fixedColumns: {
                                                leftColumns: 1
                                            },
                                            fixedheader: {
                                                header: true
                                                //footer: true
                                            }

                                        });
                                }


                            }
                        }
                        catch (e) {
                            let msg = 'Exception: ' + e + ' | Source: nodeClickEvent() Success method in ControlsWeightings.js';
                            logger.logMessage(msg);
                        }

                    })
                    .fail((error, status) => {
                        if (error.status === 401) {
                            app.showMessage(((!CWViewModel.LocaleCheckFlag() || CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : CWViewModel.ObjGeneralSettings.LocalizedTextList()[CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then((option) => {
                                    if (option === "OK")
                                        navigation.unauthorized();
                                });
                        }
                        else {
                            let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in nodeClickEvent() method in ControlsWeightings.js';
                            logger.logMessage(msg);
                        }

                    });
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: nodeClickEvent() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }
        function RefreshWeights() {
            try {
                GetControlsWeight();
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: RefreshWeights() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }
        function saveWeights() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Visualization/SaveControlWeightings?AssessmentType=" + CWViewModel.AssessmentTypeId() + "&SurveyCategoryId=" + CWViewModel.SurveyCategoryID().toString() + "&AreaId=" + CWViewModel.selectedAreaId() + "&OrgLevel=" + CWViewModel.SelectedOrgLevel() + "&ScenarioId=" + CWViewModel.SelectedScenarioId(), //to save the bu level wieghtings.
                    headers: headers,
                    type: "POST",
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify($.map(CWViewModel.WeightingsList(), function (item) {
                        return { BuId: item.BuId(), RiskAreaId: item.RiskAreaId(), WeightingValue: item.WeightingValue() };
                    }))
                })
                    .success(ajaxSuccessControlsWeights)
                    .fail(ajaxFailControlsWeights);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxCall in saveWeights() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccessControlsWeights(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult != 0) {
                        logger.logSuccess(
                            //'Controls Weightings are saved successfully.'
                            (!CWViewModel.LocaleCheckFlag() || CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ControlsWeightsSaveSuccess') == -1) ? 'Controls Weightings are saved successfully.' : CWViewModel.ObjGeneralSettings.LocalizedTextList()[CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ControlsWeightsSaveSuccess')].Name()
                            , 'Success', system.getModuleId(CWViewModel), true);
                        GetControlsWeight();
                    }
                    else {
                        logger.logError((!CWViewModel.LocaleCheckFlag() || CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InherentWeightsSaveFail') == -1) ? 'Some error occurred while saving.' : CWViewModel.ObjGeneralSettings.LocalizedTextList()[CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InherentWeightsSaveFail')].Name, 'Error', system.getModuleId(CWViewModel), true);
                    }
                }

                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in saveWeights() method in ControlsWeightings.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailControlsWeights(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(((!CWViewModel.LocaleCheckFlag() || CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : CWViewModel.ObjGeneralSettings.LocalizedTextList()[CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in saveWeights() method in ControlsWeightings.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail() method in saveWeights() method in ControlsWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }
        function checkCopyOver() {

            app.showMessage(
                //"<b> By clicking the Confirm button, I acknowledge the following: </b> \n <br> 1. I have reviewed the weightings provided on this screen \n <br> 2. Error(s) / warning(s) displayed on the screen will need to be corrected prior to executing the calculation engine and \n <br> 3. Incorrect inputs provided might results in inaccurate risk rating calculations. \n <br> <b> If you do not wish to proceed, please click Deny </b>"
                    (!CWViewModel.LocaleCheckFlag() || CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveWeightsWarning') == -1) ? "<b> By clicking the Confirm button, I acknowledge the following: </b> \n <br> 1. I have reviewed the weightings provided on this screen; \n <br> 2. Error(s) / warning(s) displayed on the screen will need to be corrected prior to executing the calculation engine; and \n <br> 3. Incorrect inputs provided might results in inaccurate risk rating calculations. \n <br> <b> If you do not wish to proceed, please Deny. </b> " : CWViewModel.ObjGeneralSettings.LocalizedTextList()[CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveWeightsWarning')].Name
                , (!CWViewModel.LocaleCheckFlag() || CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Acknowledgement') == -1) ? "Acknowledgement" : CWViewModel.ObjGeneralSettings.LocalizedTextList()[CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Acknowledgement')].Name
                , [(!CWViewModel.LocaleCheckFlag() || CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? "Confirm" : CWViewModel.ObjGeneralSettings.LocalizedTextList()[CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name
                    //"Confirm"
                    ,
                (!CWViewModel.LocaleCheckFlag() || CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DenyButton') == -1) ? "Deny" : CWViewModel.ObjGeneralSettings.LocalizedTextList()[CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DenyButton')].Name
                    //"Deny"
                ]                , true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                .then(function (option) {
                    if (option == ((!CWViewModel.LocaleCheckFlag() || CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? "Confirm" : CWViewModel.ObjGeneralSettings.LocalizedTextList()[CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name())) {
                        if (CWViewModel.EditableBusinessunitTotal() != 100.00000) {
                            logger.logError(
                                //'The total for weightings should be 100% '
                                (!CWViewModel.LocaleCheckFlag() || CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('WeightingsSaveTotalError') == -1) ? "The total for weightings should be 100.00000% " : CWViewModel.ObjGeneralSettings.LocalizedTextList()[CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('WeightingsSaveTotalError')].Name()
                                , 'Error', system.getModuleId(CWViewModel), true);
                        }
                        else {
                            CWViewModel.WeightingsList([]);
                            app.showMessage(
                                //"Would you like to copy over same weights to all other entities?"
                                (!CWViewModel.LocaleCheckFlag() || CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CopyWeightsBUAcknowledgement') == -1) ? "Would you like to copy over same weights to all Business Units?" : CWViewModel.ObjGeneralSettings.LocalizedTextList()[CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CopyWeightsBUAcknowledgement')].Name
                                //, "Save/Copy Over"
                                , (!CWViewModel.LocaleCheckFlag() || CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveCopyOver') == -1) ? "Save/Copy Over" : CWViewModel.ObjGeneralSettings.LocalizedTextList()[CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveCopyOver')].Name
                                //, ["Yes", "No"]
                                , [
                                    //"Yes"
                                    (!CWViewModel.LocaleCheckFlag() || CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('YesKeyword') == -1) ? "Yes" : CWViewModel.ObjGeneralSettings.LocalizedTextList()[CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('YesKeyword')].Name
                                    , (!CWViewModel.LocaleCheckFlag() || CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoKeyword') == -1) ? "No" : CWViewModel.ObjGeneralSettings.LocalizedTextList()[CWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoKeyword')].Name
                                    //"No"
                                ]                                , true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                                .then(function (option) {
                                    if (option == 'Yes') {
                                        //Copy to all the business units
                                        for (var j = 0; j < CWViewModel.BusinessUnits().length; j++) {
                                            for (var i = 0; i < CWViewModel.AreasOrQuestions().length; i++) {
                                                CWViewModel.WeightingsList.push(new WeightingsModel({ BuId: CWViewModel.BusinessUnits()[j].BUId(), RiskAreaId: CWViewModel.AreasOrQuestions()[i].AreaId(), WeightingValue: CWViewModel.AreasOrQuestions()[i].selectedBuWeight() }));
                                            }
                                        }
                                        saveWeights();
                                    }
                                    else {
                                        for (i = 0; i < CWViewModel.AreasOrQuestions().length; i++) {
                                            CWViewModel.WeightingsList.push(new WeightingsModel({ BuId: CWViewModel.SelectBusinessUnit().BUId(), RiskAreaId: CWViewModel.AreasOrQuestions()[i].AreaId(), WeightingValue: CWViewModel.AreasOrQuestions()[i].selectedBuWeight() }));
                                        }
                                        saveWeights();
                                    }
                                });
                        }

                    }

                    else {
                        GetControlsWeight();
                    }
                });
        }

        function BusinessLevelsModel(item) {
            try {
                var self = this;
                self.BUId = ko.observable(item.BusinessUnitId);
                self.BUName = ko.observable(item.BusinessUnitName);
                if (item.BusinessUnitName.length > 18) {
                    self.BUShortName = ko.observable((item.BusinessUnitName).substring(0, 15) + '...');
                }
                else
                    self.BUShortName = ko.observable(item.BusinessUnitName);
                if (item.BUWeightings !== undefined && item.BUWeightings !== null) {
                    var MappedWeights = $.map(item.BUWeightings, (result) => {
                        return new WeightingsModel(result);
                    });
                    self.BUWeightings = MappedWeights;
                }
                self.total = ko.computed(function () {
                    var total = 0;
                    for (var p = 0; p < self.BUWeightings.length; ++p) {
                        total += Number(Number(self.BUWeightings[p].WeightingValue()).toFixed(CWViewModel.decimalLimit()));
                    }
                    //total -= 0.000005;
                    return total.toFixed(CWViewModel.decimalLimit());
                });
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: BusinessLevelsModel() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }
        function QuestionTypeModel(item) {
            try {
                var self = this;
                self.QuestionType = ko.observable(item.QuestionType);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: QuestionTypeModel() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }
        function RiskAreaModel(item) {
            try {
                var self = this;
                if (item.QuestionType == null) {
                    self.QuestionType = '';
                }
                else
                    self.QuestionType = item.QuestionType;
                self.AreaId = ko.observable(item.AreaId);
                self.AreaName = ko.observable(item.AreaName);
                if (item.AreaName.length > 43) {
                    self.AreaShortName = ko.observable((item.AreaName).substring(0, 40) + '...');
                }
                else
                    self.AreaShortName = ko.observable(item.AreaName);
                if (item.AreaWeightings !== undefined && item.AreaWeightings !== null) {
                    var MappedWeights = $.map(item.AreaWeightings, (result) => {
                        return new WeightingsModel(result);
                    });
                    self.AreaWeightings = MappedWeights;
                }
                self.selectedBuWeight = ko.observable(0);
                self.selectedBuWeight.subscribe(function (newVal) {
                    if ($.isNumeric(newVal) && newVal >= 0.00000 && newVal <= 100.00000) {
                        var total = 0;
                        for (var i = 0; i < CWViewModel.AreasOrQuestions().length; i++) {
                            total += Number(Number(CWViewModel.AreasOrQuestions()[i].selectedBuWeight()).toFixed(CWViewModel.decimalLimit()));
                        }
                        //total -= 0.000005;
                        CWViewModel.EditableBusinessunitTotal(total.toFixed(CWViewModel.decimalLimit()));
                    }
                    else if ($.isNumeric(newVal) && (newVal < 0.00000 || newVal > 100.00000)) {
                        this.selectedBuWeight(0);
                        logger.logError('Value should be in range of (0-100).', 'Error', system.getModuleId(CWViewModel), true);
                    }
                    else {
                        this.selectedBuWeight(0);
                        logger.logError('Non-numeric values are not allowed.', 'Error', system.getModuleId(CWViewModel), true);
                    }
                }, this);

                self.Applicability = ko.observable(0);
                self.Applicability.subscribe(function (newVal) {
                    this.Applicability(newVal);
                }, this);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: RiskAreaModel() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function WeightingsModel(item) {
            try {
                var self = this;
                self.BuId = ko.observable(item.BuId);
                self.RiskAreaId = ko.observable(item.RiskAreaId);
                self.WeightingValue = ko.observable(item.WeightingValue);
                self.Applicability = ko.observable(item.Applicability);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: WeightingsModel() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }
        function TaxonomyModel(item) {
            try {
                var self = this;
                self.LevelId = ko.observable(item.LevelId);
                self.LevelName = ko.observable(item.LevelName);
                self.isMaxLevel = ko.observable(item.isMaxLevel);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: TaxonomyModel() method in ControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function SurveyCategoryModel(item) {
            try {
                var self = this;
                self.SurveyCategoryId = ko.observable(item.SurveyCategoryId);
                self.SurveyCategoryName = ko.observable(item.SurveyCategoryName);
                self.SurveyCategoryShortName = ko.observable(item.SurveyCategoryShortName);
                self.SurveyType = ko.observable(item.SurveyType);
                self.Applicability = ko.observable(item.Applicability);
                self.SurveyGroupId = ko.observable(item.SurveyGroupId);
                self.SurveyGroupFullName = ko.observable(item.SurveyGroupFullName);
                self.SurveyGroupShortName = ko.observable(item.SurveyGroupShortName);
                self.IsEditable = ko.observable(item.IsEditable);
                self.AssessmentTypeId = ko.observable(item.AssessmentTypeId);
                self.AssessmentTypeName = ko.observable(item.AssessmentTypeName);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: SurveyCategoryModel() method in AMLControlsWeightings.js';
                logger.logMessage(msg);
            }
        }

        function jsTreeModel(item) {
            var self = this;

            self.id = item.AreaLevelId.toString();
            self.text = item.AreaLevelName;
            if (CWViewModel.AreaLeveljstree()[self.id].length > 0) {
                self.nodes = $.map(CWViewModel.AreaLeveljstree()[self.id], (result) => {
                    return new jsTreeModel(result);
                });
            }
            self.state = { expanded: true };
            self.dead_node = item.DeadNode;
            self.assessmentTypeList = ko.observableArray(item.AssessmentTypeList);
            self.RA_Type = ko.observable(item.RA_Type);

        }

        //-------------------------------------------------------------------Model Definition Ends Here----------------------------------------------------------------------------
    });


//-------------------------------------------------------------------------------------------------------------------------------------------------

;
